import AdminMultiSelectActions from "components/partials/AdminMultiSelectActions"
import { ActionCreators, useAdminState, useAdminDispatch } from "../Context"

const MultiSelectActions = () => {
  const { rows } = useAdminState()
  const dispatch = useAdminDispatch()

  function onClickDelete(_, selected) {
    dispatch(ActionCreators.setToDelete(selected))
  }

  return <AdminMultiSelectActions rows={rows} onClickDelete={onClickDelete} />
}

export default MultiSelectActions
